import { Component, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AppSettings } from 'src/app/_helpers/app.settings';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/_helpers/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges, AfterViewInit {
  
  @Input() columns: any = [];
  @Input() tableData: any = [];
  @Input() controls: any = [];
  @Input() totalRec: number = 0;
  @Input() pageNo: number = 0;
  @Input() resetData: boolean = false;
  pageSize: number = AppSettings.PAGE_SIZE;
  columnHeders: any = [];
  AppSettings: any = AppSettings;
  data: MatTableDataSource<any> = new MatTableDataSource();

  @Output() controlButtonClick = new EventEmitter();
  @Output() buttonClick = new EventEmitter();
  @Output() pageChange = new EventEmitter();
  @Output() preToggle = new EventEmitter();
  @Output() sortStateChange = new EventEmitter();

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;

  constructor(
    public dialog: MatDialog
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["columns"]?.currentValue?.length) {
      this.extractHeaders();
    }
    if(changes["tableData"]?.currentValue?.length) {
      this.data = new MatTableDataSource(this.tableData);
      this.data.sort = this.sort;
      this.data._updateChangeSubscription();
    }
    if(changes["resetData"]?.currentValue == true) {
      this.tableData = [];
      this.data = new MatTableDataSource(this.tableData);
      this.data.paginator = this.paginator;
      this.data.sort = this.sort;
      this.data._updateChangeSubscription();
    }
    if(changes["totalRec"]?.currentValue && changes["totalRec"]?.currentValue != changes["totalRec"]?.previousValue) {
      this.totalRec = changes["totalRec"].currentValue;
    }
  }
  ngOnInit(): void {
    this.data.paginator = this.paginator;
    this.data = new MatTableDataSource(this.tableData);
    
  }
  ngAfterViewInit(): void {
    // this.data.paginator = this.paginator;
  }
  onControlClick(col: any, action: string) {
    this.controlButtonClick.emit({"data": col, "action": action});
  }
  extractHeaders() {
    if(!this.columns?.length) {
      return;
    }
    this.columnHeders = this.columns.map((rec: any) => {
      return rec.name;
    });
  }
  pageChanged(e: any) {
    this.pageChange.emit(e);
  }
  onButtonClick(col:any, index: number, metaInfo: any, e: any) {
    console.log("button")
    let btnStatus = e ?  'active' : 'deactive';
      const message = `Are you sure, You would like to ${btnStatus} this ${metaInfo.title}?`;
  
      const dialogData = new ConfirmDialogModel("Confirmation", message);
  
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        minWidth: "400px",
        maxWidth: "600px",
        data: dialogData
      });
  
      dialogRef.afterClosed().subscribe(dialogResult => {
        if(dialogResult) {
          this.buttonClick.emit({"data": col, "index": index, "event": e});
        } else {
          // e.source.checked = e?.checked ? false : true;
          col.checked = e ? false : true;
        }
        
      });
  }
  sortData(sortState: Sort) {
    this.sortStateChange.emit({"type": sortState?.direction, "sortColumnName": sortState?.active});
  }
}